import React from 'react';
import { Table } from 'antd';
import moment from 'moment';

const columns = [
  {
    title: 'Filename',
    dataIndex: 'original_filename',
    key: 'original_filename',
    width: '250px',
  },
  {
    title: 'Uploaded',
    dataIndex: 'created_at',
    key: 'created_at',
    render: utime => <span>{moment.unix(utime).calendar()}</span>,
    width: '150px',
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
    width: '100px',
  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
    width: '250px',
  },
];

const InventoryUploadsTable = props => {
  const { loading, uploads } = props;

  return <Table bordered loading={loading} rowKey={rec => rec.id} dataSource={uploads} columns={columns}></Table>;
};

export default InventoryUploadsTable;



// WEBPACK FOOTER //
// ./src/components/Inventory/UploadsTable.js